import React, { useEffect, useState } from 'react';

import AddParticipant from '../participant/AddParticipant';
import ParticipantList from '../participant/ParticipantList';
import DeleteConf from './DeleteConf';

import './ConfDetail.css'

interface ConfDetailProps {
    // Props for the ConnectionView component
    conferenceId: string;
    conference: string;
    conferenceName: string;
    updateSelectedConf: () => void;
    setParticipantCountInParent: (count: number) => void;
}

const ConfDetail: React.FC<ConfDetailProps> = (props) => {
    // Declare state and variables 
    const [participantCount, setParticipantCount] = useState<number>(0);

    useEffect(() => {
        props.setParticipantCountInParent(participantCount);
    }, [participantCount]);

    return (
        <div className='conf-info'>
            <div className='conf-title-button'>
                {props.conferenceName !== '' ? <h3>{props.conferenceName}</h3> : <h3>{props.conferenceId}</h3>}
                <div>
                    <AddParticipant conferenceId={props.conferenceId} currentParticipants={participantCount} />
                    <DeleteConf conferenceId={props.conferenceId} updateSelectedConf={props.updateSelectedConf} />
                </div>
            </div>
            <div className='member-list'>
                <ul >
                    <ParticipantList conferenceId={props.conferenceId} setCount={setParticipantCount} />
                </ul>
            </div>

        </ div >
    );
};

export default ConfDetail;
